export class GoogleGeometry {
	location: {lat: number, lng: number}
}



// WEBPACK FOOTER //
// ./src/app/models/google-geometry.model.ts